  import { Injectable } from '@angular/core';
  import { HttpClient } from '@angular/common/http';
  import { Observable } from 'rxjs';
  import { environment } from '@env/environment';
  import { GiftData } from './interfaces/gift';
  import { resource } from 'app/utils/resource/old';

  @Injectable({
    providedIn: 'root'
  })
  export class GiftService {

    constructor(private http: HttpClient) {}

    createGift(giftData: GiftData, lang: string = 'it'): Observable<GiftData> {
      return resource(`wsb2c://gift/save`)
        .params({ lang})
        .post<GiftData>(giftData);
    }

  }
